import type {
  ICart,
  ICartEntryDetailsOffer,
  ICartEntryDetailsReward,
  ICreateCartEntryParams,
  ILegacyCartEntry,
} from './incentive-cart';
import { ICartEntryType } from './incentive-cart';

export * from './incentive-cart/types';

export type IInRestaurantIncentive =
  | ICartEntryDetailsReward['reward']
  | ICartEntryDetailsReward['engineReward']
  | ICartEntryDetailsOffer['offer'];

export interface IUseInRestaurantCart {
  inRestaurantCart: ICart;
  isInRestaurantCartEmpty: boolean;
  addInRestaurantCartEntry: (item: ICreateCartEntryParams) => ILegacyCartEntry | null;
  removeInRestaurantCartEntry: (cartEntry: ILegacyCartEntry) => void;
  updateInRestaurantCartEntryQuantity(cartEntry: ILegacyCartEntry, quantity: number): void;
  resetInRestaurantCart: () => void;
  clearInRestaurantCartAllRewards: () => void;
  existEntryTypeInRestaurantCart: (entryType: ICartEntryType) => boolean;
  lastModificationDate: Date | undefined;
  updateLastModificationDate: (date: Date) => void;
  removeTypeFromCart: (typeToRemove: ICartEntryType) => void;
}
